import { createFileRoute, Outlet, Link } from "@tanstack/react-router";

export const Route = createFileRoute("/legal")({
  component: LegalLayout,
});

function LegalLayout() {
  return (
    <div className="mx-auto max-w-3xl px-4 py-16 md:px-6 md:py-24">
      <nav className="mb-8 text-xs text-muted-foreground">
        <Link to="/" className="hover:text-primary">Inicio</Link>
        <span className="mx-2">/</span>
        <span>Información legal</span>
      </nav>
      <div className="mb-8 flex flex-wrap gap-2 text-xs">
        <Link to="/legal/aviso-legal" activeProps={{ className: "bg-primary text-primary-foreground" }} className="rounded-full border border-border px-3 py-1 hover:bg-secondary">Aviso legal</Link>
        <Link to="/legal/privacidad" activeProps={{ className: "bg-primary text-primary-foreground" }} className="rounded-full border border-border px-3 py-1 hover:bg-secondary">Privacidad</Link>
        <Link to="/legal/cookies" activeProps={{ className: "bg-primary text-primary-foreground" }} className="rounded-full border border-border px-3 py-1 hover:bg-secondary">Cookies</Link>
        <Link to="/legal/condiciones" activeProps={{ className: "bg-primary text-primary-foreground" }} className="rounded-full border border-border px-3 py-1 hover:bg-secondary">Condiciones de reserva</Link>
      </div>
      <article className="prose prose-neutral max-w-none prose-headings:font-serif prose-h1:text-4xl prose-h2:mt-10 prose-h2:text-2xl prose-h3:text-lg prose-p:text-foreground/85 prose-a:text-primary">
        <Outlet />
      </article>
    </div>
  );
}